import React, { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Popup from 'popup/Popup';
import MainPopup from '../../MainPopup';
import { ModuleBox, AlertConfirmationChecker } from './StatusModule.css.js';
import usePrevious from 'utils/customHook/usePrevious';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { getYMDAndTimeFormatDate } from 'utils/getCustomFormatDate';
import { warningAlertConfirmInsert, warningAlertConfirmDelete } from 'redux/action/warningAlert';
import { nvl } from 'utils/nvl';
import { batteryToImg } from 'utils/utils';
import { IoMdEyeOff, IoMdEye, IoIosFlashlight } from 'react-icons/io';
import { GiLighthouse } from 'react-icons/gi';
import { moduleScnMap } from 'utils/code';

const StatusModule = (props) => {
  const cancellationToken = useCancellationToken();
  const [popupOpen, setPopupOpen] = useState(false);
  const [warningTime, setWarningTime] = useState(null);

  const dispatch = useDispatch();
  const confirmIdxs = useSelector((state) => state.warningAlert.confirm);
  const [alertConfirm, setAlertConfirm] = useState(!confirmIdxs.includes(props.moduleIdx));
  const prevAmount = usePrevious(props.status);

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (props.status !== 'blue' && props.status !== prevAmount) {
      setWarningTime(getYMDAndTimeFormatDate(new Date(props.rgstDt)));
    } else if (props.status === 'blue' && props.status !== prevAmount) {
      setWarningTime(null);
    }
  }, [props, cancellationToken]);

  // 위험알람 hooks 로직
  useEffect(() => {
    if (props.statusCode === '0') {
      if (nvl(prevAmount, null) !== null && props.status !== 'blue' && props.status !== 'none' && prevAmount !== props.status) {
        dispatch({ type: 'ALERT_INSERT', data: { ...props, userPhone: '', confirm: alertConfirm } });
      }
    }
  }, [props.status, cancellationToken]);

  // 알람팝업 표시여부 체크함수
  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    setAlertConfirm(!confirmIdxs.includes(props.moduleIdx));
  }, [confirmIdxs, cancellationToken]);

  useEffect(() => () => cancellationToken.cancel(), []);

  const onClickAlertConfirm = useCallback(
    (idx) => {
      if (alertConfirm) {
        dispatch(warningAlertConfirmInsert({ idx: idx }));
      } else {
        dispatch(warningAlertConfirmDelete({ idx: idx }));
      }
    },
    [alertConfirm]
  );

  return (
    <ModuleBox status={props.status}>
      <Popup
        trigger={
          <>
            <div
              className="moduleStatusImage"
              onClick={() => {
                setPopupOpen(true);
              }}
            >
              <img src="" alt="statusSmallIcon" />
              {props.moduleType === 'DT' ? <IoIosFlashlight /> : <GiLighthouse />}
              {batteryToImg(props.battery)}
            </div>
            <div
              className="moduleInfo"
              onClick={() => {
                setPopupOpen(true);
              }}
            >
              <div className="areaInfo">{props.areaNm === null ? '이동용' : props.areaNm}</div>
              <div className="userAndModuleName">{props.modelNm}</div>
              {props.statusCode === '1' && <div>Repeater</div>}
              <div className="warningTime">{warningTime}</div>
            </div>
          </>
        }
        modal
        closeOnDocumentClick
        open={popupOpen}
        onClose={() => {
          setPopupOpen(false);
        }}
      >
        <div style={{ background: `#272F3C`, borderRadius: `10px`, padding: `10px` }}>
          <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, fontSize: `35px`, color: 'white' }}>
            {moduleScnMap[props.moduleScn].viewTitle}&nbsp; / &nbsp;
            {props.modelNm}
          </div>
          <MainPopup {...props} />
        </div>
      </Popup>
      <AlertConfirmationChecker
        onClick={() => {
          onClickAlertConfirm(props.moduleIdx);
        }}
      >
        {alertConfirm ? <IoMdEye /> : <IoMdEyeOff />}
      </AlertConfirmationChecker>
    </ModuleBox>
  );
};

export default React.memo(StatusModule);
